import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useAddSinglewireTokenModal } from "../../../components/addSinglewireTokenModal/useAddSinglewireTokenModal";
import { useSpinner } from "../../../customHooks";
import { singlewireWebhookURL } from "../../../config/index";
import {
  Status,
  WEBHOOK_PLACEHOLDER,
  statusCode,
} from "../../../common/constants";
import { fetchSinglewireSiteData } from "./listSinglewireSiteSlice";
import { selector as singlewireSiteApi } from "./listSinglewireSiteSlice";
import { actions as singlewireActions } from "../../../components/addSinglewireTokenModal/addSinglewireTokenSlice";
import { ThunkDispatch } from "redux-thunk";
import { Action } from "redux";
import { ISinglewireSiteApi } from "../../../common/types/singlewireTypes";
import useNotification from "../../../components/notification/useNotification";

export interface ISinglewireSiteApiState {
  deviceApi: ISinglewireSiteApi;
}

export const useSinglewire = () => {
  const dispatch: ThunkDispatch<ISinglewireSiteApiState, undefined, Action> =
    useDispatch();
  const [text, setText] = useState<string>(WEBHOOK_PLACEHOLDER.PLACEHOLDER);
  const [copied, setCopied] = useState<boolean>(false);
  const [webhookUrlUpdateRequired, setWebhookUrlUpdateRequired] =
    useState<boolean>(false);
  const { singlewireTokenResponse } = useAddSinglewireTokenModal();
  const singlewireSiteResponse = useSelector(singlewireSiteApi);
  const { showWarningNotification } = useNotification();

  useSpinner(singlewireTokenResponse.status);
  useSpinner(singlewireSiteResponse.status);

  useEffect(() => {
    dispatch(fetchSinglewireSiteData())
      .then((response: any) => {
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(singlewireActions.setUserId(response.payload.userId));
        } else {
          const responseData: { message?: string; status?: number } =
            response?.payload?.response?.data;
          if (responseData?.status !== statusCode.badRequest)
            showWarningNotification(
              responseData?.message || "Something went wrong.",
            );
        }
      })
      .catch((err: any) => {});
  }, []);

  useEffect(() => {
    if (
      singlewireTokenResponse?.userId &&
      singlewireTokenResponse?.organizationId &&
      singlewireTokenResponse?.webhookSecret
    ) {
      setText(
        `${singlewireWebhookURL}/${singlewireTokenResponse.organizationId}/${singlewireTokenResponse.webhookSecret}?userId=${singlewireTokenResponse.userId}`,
      );
    }
  }, [singlewireTokenResponse.status]);

  useEffect(() => {
    if (
      singlewireSiteResponse.status === Status.SUCCESS &&
      singlewireSiteResponse?.singlewireSite?.userId &&
      singlewireSiteResponse?.singlewireSite?.organizationId &&
      singlewireSiteResponse?.singlewireSite?.webhookSecret
    ) {
      const { organizationId, webhookSecret, userId, webhookUrlUpdateRequired: updateRequired } =
        singlewireSiteResponse.singlewireSite;
      setText(
        `${singlewireWebhookURL}/${organizationId}/${webhookSecret}?userId=${userId}`,
      );
      setWebhookUrlUpdateRequired(!!updateRequired);
    } else if (singlewireSiteResponse.status === Status.SUCCESS) {
      // Handle case where webhook is not configured yet, but we have a userId
      setText(WEBHOOK_PLACEHOLDER.PLACEHOLDER);
      setWebhookUrlUpdateRequired(
        !!singlewireSiteResponse?.singlewireSite?.webhookUrlUpdateRequired,
      );
    }
  }, [singlewireSiteResponse.status]);

  return {
    text,
    setText,
    copied,
    setCopied,
    webhookUrlUpdateRequired,
  };
};
